<template>
  <div>
    <a-modal
      v-model="visible"
      :title="$t('货品选择')"
      width="960px"
      :destroyOnClose="true"
      @cancel="onCloseModel"
      @ok="onConfirm"
    >
      <a-row :gutter="16">
        <a-col :span="24" style="width: 256px">
          <a-input-search v-model="searchForm.search" :placeholder="$t('货品编码, 名称, 条码')" allowClear @search="search" />
        </a-col>
        <a-col :span="24" style="width: 256px">
          <a-button>已选择 {{ selectedRowItems.length }} 条</a-button>
        </a-col>
      </a-row>

      <div style="margin-top: 12px">
        <a-table
          :data-source="items"
          rowKey="id"
          size="small"
          :columns="columns"
          :loading="loading"
          :pagination="pagination"
          :scroll="{ y: 480 }"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="onChangeTable"
        >
          <div slot="action" slot-scope="value, item, index">
            <a-button size="small" @click="select(item)">{{ $t("选择") }}</a-button>
          </div>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { materialOption } from "@/api/option";
import { columns } from "./columns";

export default {
  props: ["visible", "client"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      columns,
      pagination: {},
      searchForm: {},
      loading: false,
      items: [],

      selectedRowKeys: [],
      selectedRowItems: [],
    };
  },
  methods: {
    onCloseModel() {
      this.selectedRowKeys = [];
      this.$emit("cancel", false);
    },
    onChangeTable(pagination, filters, sorter) {
      this.pagination = pagination;
      this.searchForm.page = pagination.current;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      this.list();
    },
    list() {
      this.loading = true;
      let searchForm = { client: this.client, ...this.searchForm };
      materialOption(searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.results;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    select(item) {
      this.$emit("select", item);
      this.onCloseModel();
    },
    resetModel() {
      this.pagination = {
        current: 1,
        total: 0,
        pageSize: 16,
        showTotal: (total) => `${this.$t("共")} ${total} ${this.$t("条")}`,
      };
      this.searchForm = { page: 1 };
      this.items = [];
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      const selectedRowItems = this.selectedRowItems.filter(
        (selectedRowItem) => this.items.findIndex((item) => item.id === selectedRowItem.id) === -1
      );
      this.selectedRowItems = [...selectedRowItems, ...selectedRows];
    },
    onConfirm() {
      this.$emit("confirm", this.selectedRowItems);
      this.onCloseModel();
    },
  },
  watch: {
    visible(status) {
      if (status) {
        this.resetModel();
        this.list();
      }
    },
  },
};
</script>
